import React, { useState, useEffect } from 'react';
import { 
  Home, Save, Edit, Eye, EyeOff, Plus, Trash2, X, Upload, Image, Star, TrendingUp, Users, Award, CheckCircle,
  Globe, Zap, Code, Smartphone, Palette, Database, Cloud, Shield, Settings, Mail, Phone, MapPin, AlertCircle,
  Check, ArrowRight, Heart, Target, Zap as ZapIcon, Shield as ShieldIcon, Users as UsersIcon, Briefcase, CreditCard, DollarSign, Headphones, MessageCircle, HelpCircle, ShoppingBag,
  Bell, ArrowLeft, Download, Send, Clock, Calendar, ShoppingCart, Play
} from 'lucide-react';
import { homepageAPI, homepageDataAPI } from '../../services/api';
import FileUpload from '../Upload/FileUpload';
import { constructApiUrl } from '../../utils/apiUtils';

const HomePageManagement = () => {
  // Icon mapping function
  const getIconComponent = (iconName) => {
    const iconMap = {
      Home, Save, Edit, Eye, EyeOff, Plus, Trash2, X, Upload, Image, Star, TrendingUp, Users, Award, CheckCircle,
      Globe, Zap, Code, Smartphone, Palette, Database, Cloud, Shield, Settings, Mail, Phone, MapPin, AlertCircle,
      Check, ArrowRight, Heart, Target, Briefcase, CreditCard, DollarSign, Headphones, MessageCircle, HelpCircle
    };
    return iconMap[iconName] || CheckCircle;
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [homeData, setHomeData] = useState({
    // Hero Section
    hero_subtitle: 'Leading Digital Agency',
    hero_title_1: 'Elevate Your',
    hero_title_2: 'Digital Journey',
    hero_title_3: 'with Niswa Info Tech',
    hero_description: 'We craft exceptional digital experiences through innovative web development, cutting-edge mobile applications, strategic digital marketing, and premium digital products that drive real business growth.',
    hero_primary_button: 'Start Your Project',
    hero_secondary_button: 'View Our Work',
    hero_primary_link: '/contact',
    hero_secondary_link: '/portfolio',
    
    // Hero Right Side Banner
    hero_banner_type: 'none',
    hero_banner_image: '',
    hero_banner_url: '',
    hero_banner_title: 'Digital Solutions',
    hero_banner_point_1: 'Innovative',
    hero_banner_point_2: 'Scalable',
    hero_banner_point_3: 'Secure',
    
    // Hero Spline Settings
    hero_spline_active: false,
    hero_spline_url: '',
    hero_spline_code: '',
    hero_spline_title: 'Interactive 3D Experience',
    hero_spline_description: 'Experience our interactive 3D elements powered by Spline',
    
    // Hero Statistics
    hero_stats: [
      { label: 'Projects Completed', value: '100+' },
      { label: 'Happy Clients', value: '50+' },
        { label: 'Years Experience', value: '5+' },
      { label: 'Team Members', value: '10+' }
    ],
    hero_trust_clients: '200+ Happy Clients',
    hero_trust_experience: '5+ Years Experience',
    
    // Services Section
    services_title: 'Our Services',
    services_description: 'We offer comprehensive digital solutions to help your business succeed in the modern world.',
    
    // Services Section - Additional Fields
    services_subtitle: 'Our Services',
    services_left_card_title: 'Strategy',
    services_left_card_points: [
      'Market Analysis',
      'Branding',
      'Design Sprint',
      'User Research',
      'Competitive Analysis'
    ],
    
    // Testimonials Section
    testimonials_title: 'What Our Clients Say',
    testimonials_description: 'Don\'t just take our word for it – hear from some of our satisfied clients.',
    

    
    // More Section (Call to Action)
    more_title: 'Ready to Transform Your Business?',
    more_description: 'Let\'s discuss your project and create something amazing together. Get a free consultation and quote today.',
    more_button_text: 'Get Free Quote',
    more_button_link: '/quote',
    more_button1_text: 'Start Your Project',
    more_button1_link: '/contact',
    
    // Newsletter Section
    newsletter_title: 'Stay Updated with Our Latest News',
    newsletter_description: 'Get the latest updates on our services, products, and industry insights.',

    // Support Section
    support_title: 'Support 24/7',
    support_description: 'Our dedicated support team is available around the clock to help you with any questions or issues.',
    support_button_text: 'support@company.com',
    support_button_link: 'mailto:support@company.com',
    support_icon: 'Headphones',
    support_large_icon: 'Headphones',
    support_extra_buttons: [],

    // Brand Logos
    brand_logos: [
      { image: '', link: 'https://example.com/logo1' },
      { image: '', link: 'https://example.com/logo2' }
    ],

    // About Us Section
    about_subtitle: 'About Us',
    about_title: 'Best Services We Provide',
    about_description: 'Every month we pick some best products for you. This month\'s best web themes & templates have arrived, chosen by our content specialists.',
            about_image: '/images/about-main.svg',
    about_experience_years: '25+',
    about_button_text: 'More About Us',
    about_button_link: '/about',
    about_features: [
      {
        title: 'High Quality Services',
        description: 'Lorem ipsum dolor sit amet consectetur. Lobortis aliquet tincidunt donec turpis nibh nunc dolor feugiat tellus.',
        icon: 'Check'
      },
      {
        title: 'Top Tier Business Acquisition',
        description: 'Lorem ipsum dolor sit amet consectetur. Lobortis aliquet tincidunt donec turpis nibh nunc dolor feugiat tellus.',
        icon: 'Award'
      }
    ],
    // Featured Products Section
    featured_products_title: 'Featured Products',
    featured_products_description: 'Discover our handpicked selection of premium products designed to enhance your digital experience.',
    featured_products_button_text: 'View All Items',
    featured_products_button_link: '/products',

    // Our Working Process Section
    working_process_title: 'Our Working Process',
    working_process_description: 'We follow a systematic approach to ensure successful project delivery and client satisfaction.',
    working_process_steps: [
      {
        step: "01",
        title: "Understanding",
        description: "We begin by thoroughly understanding your requirements, goals, and vision for the project."
      },
      {
        step: "02",
        title: "Ideation",
        description: "Our team brainstorms creative solutions and develops innovative concepts for your project."
      },
      {
        step: "03",
        title: "Develop Idea",
        description: "We transform concepts into tangible solutions using cutting-edge technologies and best practices."
      },
      {
        step: "04",
        title: "User Testing",
        description: "Rigorous testing ensures your solution meets the highest standards of quality and performance."
      }
    ],

    // Why Choose Us Section
    why_choose_us_title: 'Why Choose Us',
    why_choose_us_description: 'We deliver exceptional results through our dedicated team and proven methodologies.',
    why_choose_us_items: [
      {
        title: "Dedicated & Professional High Quality Team",
        icon: "Users",
        description: "Our experienced team of professionals is committed to delivering excellence in every project we undertake."
      },
      {
        title: "Innovative Solutions & Modern Technologies",
        icon: "Code",
        description: "We leverage cutting-edge technologies and innovative approaches to solve complex business challenges."
      },
      {
        title: "Proven Track Record & Client Satisfaction",
        icon: "Award",
        description: "With years of experience and countless successful projects, we ensure client satisfaction every time."
      }
    ],

    // Our Latest Projects Section
    latest_projects_title: 'Our Latest Projects',
    latest_projects_description: 'Explore our recent work and see how we\'ve helped businesses achieve their digital goals.',
    latest_projects_button_text: 'View All',
    latest_projects_button_link: '/portfolio',
    latest_projects_limit: 4,

    // Team Section
    team_title: 'Meet Our Team',
    team_button_text: 'View All Members',
    team_button_link: '/team',
    team_members: [
      {
        name: "John Doe",
        role: "Product Manager",
        image: "/images/team-1.svg"
      },
      {
        name: "Sarah Johnson",
        role: "UI/UX Designer",
        image: "/images/team-2.jpg"
      },
      {
        name: "Mike Chen",
        role: "Frontend Developer",
        image: "/images/team-3.jpg"
      },
      {
        name: "Emily Davis",
        role: "Backend Developer",
        image: "/images/team-4.jpg"
      }
    ],

    // Payment Methods Section
    payment_methods_title: 'Our Acceptable Payment Methods',
    payment_methods_description: 'We accept all major payment methods to make your shopping experience seamless and convenient. Choose from our wide range of secure payment options.',
    payment_methods_button_text: 'Learn More About Payments',
    payment_methods_button_link: '/payment-methods',
            payment_methods_image: '',
    payment_methods_logos: [
      {
        name: "PayPal",
        image: "/images/payment-logos/paypal.png",
        link: "https://paypal.com"
      },
      {
        name: "Bitcoin",
        image: "/images/payment-logos/bitcoin.svg",
        link: "https://bitcoin.org"
      },
      {
        name: "Mastercard",
        image: "/images/payment-logos/mastercard.svg",
        link: "https://mastercard.com"
      },
      {
        name: "VISA",
        image: "/images/payment-logos/visa.svg",
        link: "https://visa.com"
      },
      {
        name: "Stripe",
        image: "/images/payment-logos/stripe.svg",
        link: "https://stripe.com"
      },
      {
        name: "Google Pay",
        image: "/images/payment-logos/googlepay.svg",
        link: "https://pay.google.com"
      },
      {
        name: "Apple Pay",
        image: "/images/payment-logos/applepay.svg",
        link: "https://apple.com/apple-pay"
      },
      {
        name: "Amazon Pay",
        image: "/images/payment-logos/amazonpay.svg",
        link: "https://pay.amazon.com"
      },
      {
        name: "Discover",
        image: "/images/payment-logos/discover.svg",
        link: "https://discover.com"
      }
    ],

    // Pricing Table Section
    pricing_title: 'Flexible Plans For Your Business Growth',
    pricing_description: 'Choose the perfect plan that fits your business needs',
    pricing_left_title: 'Choose Your Plan',
    pricing_left_monthly_text: 'Monthly',
    pricing_left_yearly_text: 'Yearly',
    pricing_left_description: 'Switch between monthly and yearly billing to find the best option for your business.',
    pricing_button_text: 'Get Started',
    pricing_button_link: '/contact',
    pricing_whatsapp_button_text: 'Order on WhatsApp',
    pricing_whatsapp_button_icon: 'MessageCircle',
    pricing_plans: []
  });

  const [activeSection, setActiveSection] = useState('hero');
  const [isEditing, setIsEditing] = useState(false);

  // Available icons for selection
  const availableIcons = [
    { name: 'Users', component: Users },
    { name: 'Zap', component: Zap },
    { name: 'Headphones', component: Headphones },
    { name: 'Globe', component: Globe },
    { name: 'Mail', component: Mail },
    { name: 'Bell', component: Bell },
    { name: 'Star', component: Star },
    { name: 'Shield', component: Shield },
    { name: 'Cloud', component: Cloud },
    { name: 'Code', component: Code },
    { name: 'Palette', component: Palette },
    { name: 'Database', component: Database },
    { name: 'Smartphone', component: Smartphone },
    { name: 'ShoppingCart', component: ShoppingCart },
    { name: 'ArrowRight', component: ArrowRight },
    { name: 'ArrowLeft', component: ArrowLeft },
    { name: 'CheckCircle', component: CheckCircle },
    { name: 'Settings', component: Settings },
    { name: 'DollarSign', component: DollarSign },
    { name: 'Download', component: Download },
    { name: 'Send', component: Send },
    { name: 'MessageCircle', component: MessageCircle },
    { name: 'Clock', component: Clock },
    { name: 'Calendar', component: Calendar },
    { name: 'Phone', component: Phone },
    { name: 'MapPin', component: MapPin }
  ];

  const sections = [
    { id: 'hero', label: 'Hero Section', icon: Home },
    { id: 'hero-spline', label: 'Hero Spline', icon: Code },
    { id: 'hero-banner', label: 'Hero Banner', icon: Image },
    { id: 'hero-stats', label: 'Hero Statistics', icon: TrendingUp },
    { id: 'brand-logos', label: 'Brand Logos', icon: Globe },
    { id: 'services', label: 'Services', icon: Code },
    { id: 'testimonials', label: 'Testimonials', icon: Star },
    { id: 'more', label: 'Call to Action', icon: ArrowRight },
    { id: 'newsletter', label: 'Newsletter', icon: Mail },
    { id: 'support', label: 'Support', icon: Headphones },
    { id: 'team', label: 'Team', icon: Users },
    { id: 'payment-methods', label: 'Payment Methods', icon: CreditCard },
    { id: 'pricing-table', label: 'Pricing Table', icon: DollarSign },
    { id: 'featured-products', label: 'Featured Products', icon: ShoppingBag },
    { id: 'working-process', label: 'Working Process', icon: Target },
    { id: 'why-choose-us', label: 'Why Choose Us', icon: Award },
    { id: 'latest-projects', label: 'Latest Projects', icon: Briefcase },
    { id: 'about', label: 'About Us', icon: Users }
  ];

  const handleInputChange = (field, value) => {
    setHomeData(prev => ({
      ...prev,
        [field]: value
    }));
  };

  const handleArrayChange = (field, index, value) => {
    console.log(`🔍 handleArrayChange called:`, { field, index, value });
    console.log(`🔍 Current homeData[${field}]:`, homeData[field]);
    
    const newArray = [...(homeData[field] || [])];
    newArray[index] = value;
    
    console.log(`🔍 New array:`, newArray);
    
    setHomeData(prev => ({
      ...prev,
      [field]: newArray
    }));
  };

  const addArrayItem = (field, defaultValue = { label: '', value: '' }) => {
    console.log(`🔍 addArrayItem called:`, { field, defaultValue });
    console.log(`🔍 Current homeData[${field}]:`, homeData[field]);
    
    setHomeData(prev => {
      const newArray = [...(prev[field] || []), defaultValue];
      console.log(`🔍 New array for ${field}:`, newArray);
      return {
        ...prev,
        [field]: newArray
      };
    });
  };

  const removeArrayItem = (field, index) => {
    const itemName = getItemName(field, index);
    if (window.confirm(`Are you sure you want to delete this ${itemName}? This action cannot be undone.`)) {
      const newArray = homeData[field].filter((_, i) => i !== index);
      setHomeData(prev => ({
        ...prev,
        [field]: newArray
      }));
    }
  };

  // Helper function to get human-readable item names
  const getItemName = (field, index) => {
    const item = homeData[field]?.[index];
    const fieldNames = {
      hero_stats: 'statistic',
      brand_logos: 'brand logo',
      working_process_steps: 'process step',
      why_choose_us_items: 'feature',
      team_members: 'team member',
      payment_methods_logos: 'payment method',
      pricing_plans: 'pricing plan',
      support_extra_buttons: 'support button',
      about_features: 'about feature'
    };
    return fieldNames[field] || 'item';
  };

  // Fetch homepage data from API
  const fetchHomepageData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch data from both APIs
      const [homepageResponse, homepageDataResponse] = await Promise.all([
        homepageAPI.getContent(),
        homepageDataAPI.getContent()
      ]);
      
      if (homepageResponse?.data?.success && homepageDataResponse?.data?.success) {
        const homepageData = homepageResponse.data.data;
        const newsletterSupportData = homepageDataResponse.data.data;
        

        
        // Ensure proper parsing of JSON fields
        const processedData = {
          ...homepageData,
          ...newsletterSupportData, // Merge Newsletter and Support data
          hero_stats: (() => {
            try {
              return typeof homepageData.hero_stats === 'string' ? JSON.parse(homepageData.hero_stats) : (homepageData.hero_stats || []);
            } catch (error) {
              console.error('Error parsing hero_stats:', error);
              return [];
            }
          })(),
          about_features: (() => {
            try {
              return typeof homepageData.about_features === 'string' ? JSON.parse(homepageData.about_features) : (homepageData.about_features || []);
            } catch (error) {
              console.error('Error parsing about_features:', error);
              return [];
            }
          })(),
          pricing_plans: (() => {
            try {
              return typeof newsletterSupportData.pricing_plans === 'string' ? JSON.parse(newsletterSupportData.pricing_plans) : (newsletterSupportData.pricing_plans || []);
            } catch (error) {
              console.error('Error parsing pricing_plans:', error);
              return [];
            }
          })(),
          services_left_card_points: (() => {
            try {
              return typeof homepageData.services_left_card_points === 'string' ? JSON.parse(homepageData.services_left_card_points) : (homepageData.services_left_card_points || []);
            } catch (error) {
              console.error('Error parsing services_left_card_points:', error);
              return [];
            }
          })(),
          brand_logos: (() => {
            try {
              return typeof homepageData.brand_logos === 'string' ? JSON.parse(homepageData.brand_logos) : (homepageData.brand_logos || []);
            } catch (error) {
              console.error('Error parsing brand_logos:', error);
              return [];
            }
          })(),
          working_process_steps: (() => {
            try {
              return typeof homepageData.working_process_steps === 'string' ? JSON.parse(homepageData.working_process_steps) : (homepageData.working_process_steps || []);
            } catch (error) {
              console.error('Error parsing working_process_steps:', error);
              return [];
            }
          })(),
          why_choose_us_items: (() => {
            try {
              return typeof homepageData.why_choose_us_items === 'string' ? JSON.parse(homepageData.why_choose_us_items) : (homepageData.why_choose_us_items || []);
            } catch (error) {
              console.error('Error parsing why_choose_us_items:', error);
              return [];
            }
          })(),
          team_members: (() => {
            try {
              return typeof newsletterSupportData.team_members === 'string' ? JSON.parse(newsletterSupportData.team_members) : (newsletterSupportData.team_members || []);
            } catch (error) {
              console.error('Error parsing team_members:', error);
              return [];
            }
          })(),
          payment_methods_logos: (() => {
            try {
              return typeof newsletterSupportData.payment_methods_logos === 'string' ? JSON.parse(newsletterSupportData.payment_methods_logos) : (newsletterSupportData.payment_methods_logos || []);
            } catch (error) {
              console.error('Error parsing payment_methods_logos:', error);
              return [];
            }
          })(),
          support_extra_buttons: (() => {
            try {
              return typeof newsletterSupportData.support_extra_buttons === 'string' ? JSON.parse(newsletterSupportData.support_extra_buttons) : (newsletterSupportData.support_extra_buttons || []);
            } catch (error) {
              console.error('Error parsing support_extra_buttons:', error);
              return [];
            }
          })()
        };
        

        
        setHomeData(processedData);
        setError(null);
      } else {
        console.error('Failed to fetch homepage data:', homepageResponse, homepageDataResponse);
        setError('Failed to load homepage data');
      }
    } catch (err) {
      console.error('Error fetching homepage data:', err);
      setError('Error loading homepage data');
    } finally {
      setLoading(false);
    }
  };

  // Save homepage data
  const saveHomepageData = async () => {
    try {
      setSaving(true);
      setError(null);
      
      console.log('🔍 Saving homepage data...');
      console.log('Data being sent:', homeData);
      console.log('Data keys:', Object.keys(homeData));
      
      // Check authentication
      const token = localStorage.getItem('authToken');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      console.log('Token exists:', !!token);
      console.log('User exists:', !!user);
      console.log('Token length:', token?.length);
      console.log('User role:', user.role);
      console.log('Is admin:', user.role === 'admin');
      
      if (!token) {
        setError('No authentication token found. Please log in again.');
        return;
      }
      
      if (!user.id) {
        setError('No user data found. Please log in again.');
        return;
      }
      
      if (user.role !== 'admin') {
        setError('Admin access required. Current role: ' + user.role);
        return;
      }

      // Test token validity first
      try {
        const testResponse = await fetch(constructApiUrl('auth/profile'), {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!testResponse.ok) {
          console.error('Token validation failed:', testResponse.status, testResponse.statusText);
          setError('Authentication token is invalid. Please log in again.');
          return;
        }
        
        console.log('✅ Token validation successful');
      } catch (tokenError) {
        console.error('Token validation error:', tokenError);
        setError('Authentication failed. Please log in again.');
        return;
      }

      // Send data in smaller chunks to avoid max_allowed_packet error
      const dataChunks = {
        about: {
          about_subtitle: homeData.about_subtitle,
          about_title: homeData.about_title,
          about_description: homeData.about_description,
          about_image: homeData.about_image,
          about_experience_years: homeData.about_experience_years,
          about_button_text: homeData.about_button_text,
          about_button_link: homeData.about_button_link,
          about_features: homeData.about_features
        },
        hero: {
          hero_title: homeData.hero_title,
          hero_subtitle: homeData.hero_subtitle,
          hero_description: homeData.hero_description,
          hero_title_1: homeData.hero_title_1,
          hero_title_2: homeData.hero_title_2,
          hero_title_3: homeData.hero_title_3,
          hero_primary_button: homeData.hero_primary_button,
          hero_secondary_button: homeData.hero_secondary_button,
          hero_primary_link: homeData.hero_primary_link,
          hero_secondary_link: homeData.hero_secondary_link,
          hero_banner_type: homeData.hero_banner_type,
          hero_banner_image: homeData.hero_banner_image,
          hero_banner_url: homeData.hero_banner_url,
          hero_banner_title: homeData.hero_banner_title,
          hero_banner_point_1: homeData.hero_banner_point_1,
          hero_banner_point_2: homeData.hero_banner_point_2,
          hero_banner_point_3: homeData.hero_banner_point_3,
          hero_spline_active: homeData.hero_spline_active,
          hero_spline_url: homeData.hero_spline_url,
          hero_spline_code: homeData.hero_spline_code,
          hero_spline_title: homeData.hero_spline_title,
          hero_spline_description: homeData.hero_spline_description,
          hero_stats: homeData.hero_stats,
          hero_trust_clients: homeData.hero_trust_clients,
          hero_trust_experience: homeData.hero_trust_experience
        },
        services: {
          services_title: homeData.services_title,
          services_description: homeData.services_description,
          services_subtitle: homeData.services_subtitle,
          services_left_card_title: homeData.services_left_card_title,
          services_left_card_points: homeData.services_left_card_points
        },
        working_process: {
          working_process_title: homeData.working_process_title,
          working_process_description: homeData.working_process_description,
          working_process_steps: homeData.working_process_steps
        },
        featured_products: {
          featured_products_title: homeData.featured_products_title,
          featured_products_description: homeData.featured_products_description,
          featured_products_button_text: homeData.featured_products_button_text,
          featured_products_button_link: homeData.featured_products_button_link
        },
        why_choose_us: {
          why_choose_us_title: homeData.why_choose_us_title,
          why_choose_us_description: homeData.why_choose_us_description,
          why_choose_us_items: homeData.why_choose_us_items
        },
        latest_projects: {
          latest_projects_title: homeData.latest_projects_title,
          latest_projects_description: homeData.latest_projects_description,
          latest_projects_button_text: homeData.latest_projects_button_text,
          latest_projects_button_link: homeData.latest_projects_button_link,
          latest_projects_limit: homeData.latest_projects_limit
        },
        team: {
          team_title: homeData.team_title,
          team_button_text: homeData.team_button_text,
          team_button_link: homeData.team_button_link,
          team_members: homeData.team_members
        },
        payment_methods: {
          payment_methods_title: homeData.payment_methods_title,
          payment_methods_description: homeData.payment_methods_description,
          payment_methods_button_text: homeData.payment_methods_button_text,
          payment_methods_button_link: homeData.payment_methods_button_link,
          payment_methods_image: homeData.payment_methods_image,
          payment_methods_logos: homeData.payment_methods_logos
        },
        testimonials: {
          testimonials_title: homeData.testimonials_title,
          testimonials_description: homeData.testimonials_description
        },
        more: {
          more_title: homeData.more_title,
          more_description: homeData.more_description,
          more_button_text: homeData.more_button_text,
          more_button_link: homeData.more_button_link,
          more_button1_text: homeData.more_button1_text,
          more_button1_link: homeData.more_button1_link
        },
        newsletter: {
          newsletter_title: homeData.newsletter_title,
          newsletter_description: homeData.newsletter_description,
          newsletter_button_text: homeData.newsletter_button_text
        },
        support: {
          support_title: homeData.support_title,
          support_description: homeData.support_description,
          support_button_text: homeData.support_button_text,
          support_button_link: homeData.support_button_link,
          support_icon: homeData.support_icon,
          support_large_icon: homeData.support_large_icon,
          support_extra_buttons: homeData.support_extra_buttons
        },
        team: {
          team_title: homeData.team_title,
          team_description: homeData.team_description,
          team_button_text: homeData.team_button_text,
          team_button_link: homeData.team_button_link,
          team_members: homeData.team_members
        },
        payment_methods: {
          payment_methods_title: homeData.payment_methods_title,
          payment_methods_description: homeData.payment_methods_description,
          payment_methods_button_text: homeData.payment_methods_button_text,
          payment_methods_button_link: homeData.payment_methods_button_link,
          payment_methods_image: homeData.payment_methods_image,
          payment_methods_logos: homeData.payment_methods_logos
        },
        pricing_table: {
          pricing_title: homeData.pricing_title,
          pricing_description: homeData.pricing_description,
          pricing_left_title: homeData.pricing_left_title,
          pricing_left_monthly_text: homeData.pricing_left_monthly_text,
          pricing_left_yearly_text: homeData.pricing_left_yearly_text,
          pricing_left_description: homeData.pricing_left_description,
          pricing_button_text: homeData.pricing_button_text,
          pricing_button_link: homeData.pricing_button_link,
          pricing_whatsapp_button_text: homeData.pricing_whatsapp_button_text,
          pricing_whatsapp_button_icon: homeData.pricing_whatsapp_button_icon,
          pricing_plans: homeData.pricing_plans
        },
        brand_logos: {
          brand_logos: homeData.brand_logos
        }
      };

      // Save each chunk separately
      for (const [sectionName, sectionData] of Object.entries(dataChunks)) {
        const filteredData = {};
        Object.keys(sectionData).forEach(key => {
          if (sectionData[key] !== undefined && sectionData[key] !== null) {
            filteredData[key] = sectionData[key];
          }
        });

        if (Object.keys(filteredData).length > 0) {
          console.log(`📦 Saving ${sectionName} section:`, Object.keys(filteredData).length, 'fields');
          console.log(`${sectionName} data:`, filteredData);
          
          // Convert arrays to JSON strings for database storage
          const processedData = { ...filteredData };
          Object.keys(processedData).forEach(key => {
            if (Array.isArray(processedData[key])) {
              processedData[key] = JSON.stringify(processedData[key]);
            }
          });
          
          console.log(`${sectionName} processed data:`, processedData);
          
          // Use different API for Newsletter and Support sections
          let response;
          if (sectionName === 'newsletter' || sectionName === 'support' || sectionName === 'team' || sectionName === 'payment_methods' || sectionName === 'pricing_table') {
                      if (sectionName === 'pricing_table') {
            console.log('🔍 Pricing table debug - processedData:', processedData);
          }
            response = await homepageDataAPI.updateContent(processedData);
          } else {
            response = await homepageAPI.updateContent(processedData);
          }
          
          console.log(`${sectionName} response:`, response);
          console.log(`${sectionName} response.data:`, response.data);
          console.log(`${sectionName} success:`, response.data.success);
          console.log(`${sectionName} message:`, response.data.message);
          
          if (!response.data.success) {
            throw new Error(`Failed to save ${sectionName} section: ${response.data.message}`);
          }
        }
      }
      
      console.log('✅ Homepage data saved successfully!');
      setIsEditing(false);
      // Optionally refresh data
      await fetchHomepageData();
      
    } catch (err) {
      console.error('❌ Error saving homepage data:', err);
      console.log('Error response:', err.response?.data);
      console.log('Error status:', err.response?.status);
      console.log('Error message:', err.message);
      console.log('Full error:', err);
      
      if (err.response?.status === 401) {
        setError('Authentication failed. Please log in again.');
      } else if (err.response?.status === 413 || err.response?.data?.error?.includes('max_allowed_packet')) {
        setError('Data packet too large. Please try saving smaller sections or contact support.');
      } else if (err.response?.data?.error?.includes('Incorrect arguments to mysqld_stmt_execute')) {
        setError('Database field mismatch. Please contact support.');
      } else {
        setError(err.response?.data?.message || err.message || 'Server error. Please try again or contact support.');
      }
    } finally {
      setSaving(false);
    }
  };

  // Save specific section data
  const saveSectionData = async (sectionName) => {
    try {
      setSaving(true);
      setError(null);
      
      console.log(`🔍 Saving ${sectionName} section...`);
      
      // Check authentication
      const token = localStorage.getItem('authToken');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (!token || !user.id || user.role !== 'admin') {
        setError('Admin authentication required');
        return;
      }

      // Get only the fields for the specific section
      const sectionFields = {};
      const sectionFieldMappings = {
        'about': ['about_subtitle', 'about_title', 'about_description', 'about_image', 'about_experience_years', 'about_button_text', 'about_button_link', 'about_features'],
        'hero': ['hero_subtitle', 'hero_title_1', 'hero_title_2', 'hero_title_3', 'hero_description', 'hero_primary_button', 'hero_secondary_button', 'hero_primary_link', 'hero_secondary_link'],
        'services': ['services_title', 'services_description', 'services_subtitle', 'services_left_card_title', 'services_left_card_points'],
        'testimonials': ['testimonials_title', 'testimonials_description'],
        'more': ['more_title', 'more_description', 'more_button_text', 'more_button_link', 'more_button1_text', 'more_button1_link'],
        'newsletter': ['newsletter_title', 'newsletter_description', 'newsletter_button_text'],
        'featured-products': ['featured_products_title', 'featured_products_description', 'featured_products_button_text', 'featured_products_button_link'],
        'working-process': ['working_process_title', 'working_process_description', 'working_process_steps'],
        'why-choose-us': ['why_choose_us_title', 'why_choose_us_description', 'why_choose_us_items'],
        'latest-projects': ['latest_projects_title', 'latest_projects_description', 'latest_projects_button_text', 'latest_projects_button_link', 'latest_projects_limit'],
        'team': ['team_title', 'team_button_text', 'team_button_link', 'team_members'],
        'payment-methods': ['payment_methods_title', 'payment_methods_description', 'payment_methods_button_text', 'payment_methods_button_link', 'payment_methods_image', 'payment_methods_logos'],
        'pricing-table': ['pricing_title', 'pricing_description', 'pricing_left_title', 'pricing_left_monthly_text', 'pricing_left_yearly_text', 'pricing_left_description', 'pricing_button_text', 'pricing_button_link', 'pricing_whatsapp_button_text', 'pricing_whatsapp_button_icon', 'pricing_plans']
      };

      const fieldsToSend = sectionFieldMappings[sectionName] || [];
      fieldsToSend.forEach(field => {
        if (homeData[field] !== undefined && homeData[field] !== null && homeData[field] !== '') {
          sectionFields[field] = homeData[field];
        }
      });



      console.log(`📦 Sending ${sectionName} fields:`, Object.keys(sectionFields));
      console.log(`📦 Section data:`, sectionFields);
      console.log(`🔑 Token exists:`, !!localStorage.getItem('authToken'));
      console.log(`👤 User role:`, user.role);
      
      // Use different API for specific sections
      let response;
      if (sectionName === 'newsletter' || sectionName === 'support' || sectionName === 'team' || sectionName === 'payment-methods' || sectionName === 'pricing-table') {
        response = await homepageDataAPI.updateContent(sectionFields);
      } else {
        response = await homepageAPI.updateContent(sectionFields);
      }
      
      if (response?.data?.success) {
        console.log(`✅ ${sectionName} section saved successfully!`);
        setIsEditing(false);
        await fetchHomepageData();
      } else {
        setError(response?.data?.message || `Failed to save ${sectionName} section`);
      }
      
    } catch (err) {
      console.error(`❌ Error saving ${sectionName} section:`, err);
      
      if (err.response?.data?.error?.includes('max_allowed_packet')) {
        setError('Data packet too large. Please try saving individual fields.');
      } else {
        setError(err.response?.data?.message || err.message || 'Server error. Please try again.');
      }
    } finally {
      setSaving(false);
    }
  };

  // Save support section data
  const saveSupportData = async () => {
    try {
      setSaving(true);
      setError(null);
      
      console.log('🔍 Saving support section...');
      
      // Check authentication
      const token = localStorage.getItem('authToken');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (!token || !user.id || user.role !== 'admin') {
        setError('Admin authentication required');
        return;
      }

      const supportData = {
        support_title: homeData.support_title,
        support_description: homeData.support_description,
        support_button_text: homeData.support_button_text,
        support_button_link: homeData.support_button_link,
        support_icon: homeData.support_icon,
        support_large_icon: homeData.support_large_icon,
        support_extra_buttons: Array.isArray(homeData.support_extra_buttons) ? JSON.stringify(homeData.support_extra_buttons) : homeData.support_extra_buttons
      };

      console.log('📦 Support data:', supportData);
      
      const response = await homepageDataAPI.updateContent(supportData);
      
      console.log('Support response:', response);
      console.log('Support response.data:', response.data);
      console.log('Support success:', response.data.success);
      console.log('Support message:', response.data.message);
      
      if (response?.data?.success) {
        console.log('✅ Support section saved successfully!');
        setIsEditing(false);
        await fetchHomepageData();
      } else {
        setError(response?.data?.message || 'Failed to save support section');
      }
      
    } catch (err) {
      console.error('❌ Error saving support section:', err);
      
      if (err.response?.data?.error?.includes('max_allowed_packet')) {
        setError('Data packet too large. Please try saving individual fields.');
      } else {
        setError(err.response?.data?.message || err.message || 'Server error. Please try again.');
      }
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    fetchHomepageData();
  }, []);

  const renderHeroSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Hero Section Content</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Subtitle
          </label>
        <input
          type="text"
            value={homeData.hero_subtitle}
            onChange={(e) => handleInputChange('hero_subtitle', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Leading Digital Agency"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Title Line 1
          </label>
          <input
            type="text"
            value={homeData.hero_title_1}
            onChange={(e) => handleInputChange('hero_title_1', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Elevate Your"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Title Line 2
          </label>
          <input
            type="text"
            value={homeData.hero_title_2}
            onChange={(e) => handleInputChange('hero_title_2', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Digital Journey"
          />
        </div>
      <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Title Line 3
          </label>
        <input
          type="text"
            value={homeData.hero_title_3}
            onChange={(e) => handleInputChange('hero_title_3', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="with Niswa Info Tech"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.hero_description}
          onChange={(e) => handleInputChange('hero_description', e.target.value)}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="We craft exceptional digital experiences..."
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Primary Button Text
          </label>
          <input
            type="text"
            value={homeData.hero_primary_button}
            onChange={(e) => handleInputChange('hero_primary_button', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Start Your Project"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Secondary Button Text
          </label>
          <input
            type="text"
            value={homeData.hero_secondary_button}
            onChange={(e) => handleInputChange('hero_secondary_button', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="View Our Work"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Primary Button Link
          </label>
            <input
              type="text"
            value={homeData.hero_primary_link}
            onChange={(e) => handleInputChange('hero_primary_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/contact"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Secondary Button Link
          </label>
            <input
              type="text"
            value={homeData.hero_secondary_link}
            onChange={(e) => handleInputChange('hero_secondary_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/portfolio"
          />
          </div>
      </div>
    </div>
  );

  const renderHeroBannerSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Hero Right Side Banner</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Banner Type
        </label>
        <select
          value={homeData.hero_banner_type}
          onChange={(e) => handleInputChange('hero_banner_type', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
          <option value="none">Nothing</option>
          <option value="image">Image Upload</option>
          <option value="url">URL Link</option>
        </select>
      </div>

      {homeData.hero_banner_type === 'image' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Banner Image/Animation
          </label>
          <div className="space-y-3">
            {/* URL Input */}
            <div>
              <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                Image/Animation URL
              </label>
              <input
                type="text"
                value={homeData.hero_banner_image}
                onChange={(e) => handleInputChange('hero_banner_image', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="https://example.com/image.jpg or https://lottiefiles.com/animations/example.json"
              />
            </div>
            
            {/* File Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                Upload Image/Animation
              </label>
              <FileUpload
                multiple={false}
                accept="image/*,application/json,.gif,.json"
                maxSize={10 * 1024 * 1024} // 10MB
                maxFiles={1}
                uploadType="animation"
                onUploadComplete={(files) => {
                  if (files.length > 0) {
                    handleInputChange('hero_banner_image', files[0].url);
                  }
                }}
                onUploadError={(errors) => {
                  console.error('Upload errors:', errors);
                }}
                className="w-full"
              />
            </div>
            
            {/* Preview */}
            {homeData.hero_banner_image && (
              <div className="mt-3">
                <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                  Preview
                </label>
                <div className="w-full h-32 bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden flex items-center justify-center">
                  {homeData.hero_banner_image.toLowerCase().endsWith('.json') ? (
                    <div className="text-center">
                      <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-2">
                        <Play className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </div>
                      <p className="text-xs text-gray-600 dark:text-gray-400">Lottie Animation</p>
                    </div>
                  ) : homeData.hero_banner_image.toLowerCase().endsWith('.gif') ? (
                    <img 
                      src={homeData.hero_banner_image} 
                      alt="Banner preview" 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <img 
                      src={homeData.hero_banner_image} 
                      alt="Banner preview" 
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {homeData.hero_banner_type === 'url' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Banner URL
          </label>
        <input
          type="text"
            value={homeData.hero_banner_url}
            onChange={(e) => handleInputChange('hero_banner_url', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="https://example.com"
        />
      </div>
      )}
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Banner Title
        </label>
        <input
          type="text"
          value={homeData.hero_banner_title}
          onChange={(e) => handleInputChange('hero_banner_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Digital Solutions"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Point 1
          </label>
          <input
            type="text"
            value={homeData.hero_banner_point_1}
            onChange={(e) => handleInputChange('hero_banner_point_1', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Innovative"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Point 2
          </label>
          <input
            type="text"
            value={homeData.hero_banner_point_2}
            onChange={(e) => handleInputChange('hero_banner_point_2', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Scalable"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Point 3
          </label>
          <input
            type="text"
            value={homeData.hero_banner_point_3}
            onChange={(e) => handleInputChange('hero_banner_point_3', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Secure"
          />
        </div>
      </div>
    </div>
  );

  const renderHeroSplineSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Hero Spline Settings</h3>
      
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-6">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <Code className="h-5 w-5 text-blue-400" />
          </div>
          <div className="ml-3">
            <p className="text-sm text-blue-700 dark:text-blue-300">
              <strong>Spline Integration:</strong> When Spline is active, it will replace the banner/image section in the hero area. 
              You can add either a Spline URL or embed code. The Spline element will provide an interactive 3D experience for your visitors.
            </p>
          </div>
        </div>
      </div>

      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          <input
            type="checkbox"
            checked={homeData.hero_spline_active}
            onChange={(e) => handleInputChange('hero_spline_active', e.target.checked)}
            className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
          />
          Enable Spline in Hero Section
        </label>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          When enabled, Spline will replace the banner/image section. When disabled, the banner/image section will be shown.
        </p>
      </div>

      {homeData.hero_spline_active && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Spline Title
            </label>
            <input
              type="text"
              value={homeData.hero_spline_title}
              onChange={(e) => handleInputChange('hero_spline_title', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Interactive 3D Experience"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Spline Description
            </label>
            <textarea
              value={homeData.hero_spline_description}
              onChange={(e) => handleInputChange('hero_spline_description', e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Experience our interactive 3D elements powered by Spline"
            />
          </div>

          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Spline URL (Recommended)
              </label>
              <input
                type="url"
                value={homeData.hero_spline_url}
                onChange={(e) => handleInputChange('hero_spline_url', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="https://my.spline.design/untitled-1234567890/"
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Enter the Spline URL from your Spline project. This is the recommended method.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Spline Embed Code (Alternative)
              </label>
              <textarea
                value={homeData.hero_spline_code}
                onChange={(e) => handleInputChange('hero_spline_code', e.target.value)}
                rows={6}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white font-mono text-sm"
                placeholder="<iframe src='https://my.spline.design/untitled-1234567890/' frameborder='0' width='100%' height='100%'></iframe>"
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Alternative: Paste the full embed code from Spline. Use this if the URL method doesn't work.
              </p>
            </div>
          </div>

          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <AlertCircle className="h-5 w-5 text-yellow-400" />
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700 dark:text-yellow-300">
                  <strong>Note:</strong> When Spline is active, the banner/image section will be hidden. 
                  Make sure your Spline project is properly configured and accessible.
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );

  const renderHeroStatsSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Hero Statistics</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Trust Clients Text
          </label>
          <input
            type="text"
            value={homeData.hero_trust_clients}
            onChange={(e) => handleInputChange('hero_trust_clients', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="200+ Happy Clients"
          />
        </div>
      <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Trust Experience Text
          </label>
          <input
            type="text"
            value={homeData.hero_trust_experience}
            onChange={(e) => handleInputChange('hero_trust_experience', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="5+ Years Experience"
          />
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Statistics Items
          </label>
          <button
            onClick={() => addArrayItem('hero_stats', { label: '', value: '' })}
            className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Stat
          </button>
        </div>
        
        <div className="space-y-4">
          {Array.isArray(homeData.hero_stats) && homeData.hero_stats.map((stat, index) => (
            <div key={index} className="flex items-center gap-4 p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
              <div className="flex-1">
                <input
                  type="text"
                  value={stat.label}
                  onChange={(e) => handleArrayChange('hero_stats', index, { ...stat, label: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  placeholder="Label"
                />
              </div>
              <div className="flex-1">
            <input
              type="text"
                  value={stat.value}
                  onChange={(e) => handleArrayChange('hero_stats', index, { ...stat, value: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  placeholder="Value"
                />
              </div>
              <button
                onClick={() => removeArrayItem('hero_stats', index)}
                className="p-2 text-red-600 hover:text-red-700 transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </button>
          </div>
        ))}
        </div>
      </div>
    </div>
  );

  const renderBrandLogosSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Brand Logos</h3>
      <div className="flex items-center justify-between mb-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Logos (Image or Link - both optional)
        </label>
        <button
          onClick={() => addArrayItem('brand_logos', { image: '', link: '' })}
          className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <Plus className="w-4 h-4" />
          Add Logo
        </button>
      </div>
      <div className="space-y-4">
        {Array.isArray(homeData.brand_logos) && homeData.brand_logos.length > 0 ? (
          homeData.brand_logos.map((logo, index) => (
            <div key={index} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Image Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Logo Image/Animation (Optional)
                  </label>
                  <div className="space-y-3">
                    {/* URL Input */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                        Image/Animation URL
                      </label>
                      <input
                        type="text"
                        value={logo.image || ''}
                        onChange={(e) => handleArrayChange('brand_logos', index, { ...logo, image: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        placeholder="https://example.com/logo.png or https://lottiefiles.com/animations/logo.json"
                      />
                    </div>
                    
                    {/* File Upload */}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                        Upload Image/Animation
                      </label>
                      <FileUpload
                        multiple={false}
                        accept="image/*,application/json,.gif,.json"
                        maxSize={5 * 1024 * 1024} // 5MB
                        maxFiles={1}
                        uploadType="animation"
                        onUploadComplete={(files) => {
                          if (files.length > 0) {
                            handleArrayChange('brand_logos', index, { ...logo, image: files[0].url });
                          }
                        }}
                        onUploadError={(errors) => {
                          console.error('Upload errors:', errors);
                        }}
                        className="w-full"
                      />
                    </div>
                    
                    {/* Preview */}
                    {logo.image && (
                      <div className="mt-2">
                        <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                          Preview
                        </label>
                        <div className="w-20 h-20 bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden flex items-center justify-center">
                          {logo.image.toLowerCase().endsWith('.json') ? (
                            <div className="text-center">
                              <div className="w-6 h-6 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-1">
                                <Play className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                              </div>
                              <p className="text-xs text-gray-600 dark:text-gray-400">Lottie</p>
                            </div>
                          ) : logo.image.toLowerCase().endsWith('.gif') ? (
                            <img 
                              src={logo.image} 
                              alt="Logo preview" 
                              className="w-full h-full object-contain"
                            />
                          ) : (
                            <img 
                              src={logo.image} 
                              alt="Logo preview" 
                              className="w-full h-full object-contain"
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Link Input */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Logo Link (Optional)
                  </label>
                  <input
                    type="text"
                    value={logo.link || ''}
                    onChange={e => handleArrayChange('brand_logos', index, { ...logo, link: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="https://partner.com"
                  />
                </div>
              </div>
              
              {/* Remove Button */}
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => removeArrayItem('brand_logos', index)}
                  className="p-2 text-red-600 hover:text-red-700 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500 dark:text-gray-400">No logos added yet.</div>
        )}
      </div>
    </div>
  );

  const renderServicesSection = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Services Section</h3>
        <button
          onClick={() => saveSectionData('services')}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 transition-colors"
        >
          {saving ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          ) : (
            <Save className="w-4 h-4" />
          )}
          {saving ? 'Saving...' : 'Save Services'}
        </button>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.services_title}
          onChange={(e) => handleInputChange('services_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Our Services"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.services_description}
          onChange={(e) => handleInputChange('services_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="We offer comprehensive digital solutions..."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Subtitle
        </label>
        <input
          type="text"
          value={homeData.services_subtitle}
          onChange={(e) => handleInputChange('services_subtitle', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Our Services"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Left Card Title
        </label>
        <input
          type="text"
          value={homeData.services_left_card_title}
          onChange={(e) => handleInputChange('services_left_card_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Strategy"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Points (comma-separated)
        </label>
        <textarea
          value={Array.isArray(homeData.services_left_card_points) ? homeData.services_left_card_points.join(', ') : ''}
          onChange={(e) => handleInputChange('services_left_card_points', e.target.value.split(',').map(p => p.trim()))}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Market Analysis, Branding, Design Sprint, User Research, Competitive Analysis"
        />
      </div>
    </div>
  );

  const renderTestimonialsSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Testimonials Section</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.testimonials_title}
          onChange={(e) => handleInputChange('testimonials_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="What Our Clients Say"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.testimonials_description}
          onChange={(e) => handleInputChange('testimonials_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Don't just take our word for it..."
        />
      </div>
    </div>
  );



  const renderMoreSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">More Section (Call to Action)</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.more_title}
          onChange={(e) => handleInputChange('more_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Ready to Transform Your Business?"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.more_description}
          onChange={(e) => handleInputChange('more_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Let's discuss your project..."
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Text
          </label>
          <input
            type="text"
            value={homeData.more_button_text}
            onChange={(e) => handleInputChange('more_button_text', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Get Free Quote"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Link
          </label>
          <input
            type="text"
            value={homeData.more_button_link}
            onChange={(e) => handleInputChange('more_button_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/quote"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button 1 Text
          </label>
          <input
            type="text"
            value={homeData.more_button1_text}
            onChange={(e) => handleInputChange('more_button1_text', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Start Your Project"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button 1 Link
          </label>
          <input
            type="text"
            value={homeData.more_button1_link}
            onChange={(e) => handleInputChange('more_button1_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/contact"
          />
        </div>
      </div>
    </div>
  );

  const renderNewsletterSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Newsletter Section</h3>
      
        <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
          <input
          type="text"
          value={homeData.newsletter_title}
          onChange={(e) => handleInputChange('newsletter_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Stay Updated with Our Latest News"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.newsletter_description}
          onChange={(e) => handleInputChange('newsletter_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Get the latest updates..."
          />
        </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Button Text
        </label>
        <input
          type="text"
          value={homeData.newsletter_button_text || 'Subscribe Now'}
          onChange={(e) => handleInputChange('newsletter_button_text', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Subscribe Now"
        />
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
        <p className="text-sm text-blue-700 dark:text-blue-300">
          <strong>Info:</strong> All newsletter fields including button text can be edited and saved.
        </p>
      </div>
    </div>
  );

  const renderFeaturedProductsSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Featured Products Section</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.featured_products_title}
          onChange={(e) => handleInputChange('featured_products_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Featured Products"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.featured_products_description}
          onChange={(e) => handleInputChange('featured_products_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Discover our handpicked selection of premium products..."
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Text
          </label>
          <input
            type="text"
            value={homeData.featured_products_button_text}
            onChange={(e) => handleInputChange('featured_products_button_text', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="View All Items"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Link
          </label>
          <input
            type="text"
            value={homeData.featured_products_button_link}
            onChange={(e) => handleInputChange('featured_products_button_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/products"
          />
        </div>
      </div>
    </div>
  );

  const renderWorkingProcessSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Our Working Process Section</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.working_process_title}
          onChange={(e) => handleInputChange('working_process_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Our Working Process"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.working_process_description}
          onChange={(e) => handleInputChange('working_process_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="We follow a systematic approach to ensure successful project delivery and client satisfaction."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Steps
        </label>
        <div className="flex items-center justify-between mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Process Steps
          </label>
          <button
            onClick={() => addArrayItem('working_process_steps', { step: '', title: '', description: '' })}
            className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Step
          </button>
        </div>
        <div className="space-y-4">
          {Array.isArray(homeData.working_process_steps) && homeData.working_process_steps.length > 0 ? (
            homeData.working_process_steps.map((step, index) => (
              <div key={index} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Step Number
                    </label>
                    <input
                      type="text"
                      value={step.step}
                      onChange={(e) => handleArrayChange('working_process_steps', index, { ...step, step: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="01"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Title
                    </label>
                    <input
                      type="text"
                      value={step.title}
                      onChange={(e) => handleArrayChange('working_process_steps', index, { ...step, title: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="Understanding"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Description
                    </label>
                    <textarea
                      value={step.description}
                      onChange={(e) => handleArrayChange('working_process_steps', index, { ...step, description: e.target.value })}
                      rows={2}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="We begin by thoroughly understanding your requirements, goals, and vision for the project."
                    />
                  </div>
                </div>
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => removeArrayItem('working_process_steps', index)}
                    className="p-2 text-red-600 hover:text-red-700 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-gray-500 dark:text-gray-400">No steps added yet.</div>
          )}
        </div>
      </div>
    </div>
  );

  const renderWhyChooseUsSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Why Choose Us Section</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.why_choose_us_title}
          onChange={(e) => handleInputChange('why_choose_us_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Why Choose Us"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.why_choose_us_description}
          onChange={(e) => handleInputChange('why_choose_us_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="We deliver exceptional results through our dedicated team and proven methodologies."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Items
        </label>
        <div className="flex items-center justify-between mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Why Choose Us Items
          </label>
          <button
            onClick={() => addArrayItem('why_choose_us_items', { title: '', icon: 'Users', description: '' })}
            className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Item
          </button>
        </div>
        <div className="space-y-4">
          {Array.isArray(homeData.why_choose_us_items) && homeData.why_choose_us_items.length > 0 ? (
            homeData.why_choose_us_items.map((item, index) => (
              <div key={index} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Title
                    </label>
                    <input
                      type="text"
                      value={item.title}
                      onChange={(e) => handleArrayChange('why_choose_us_items', index, { ...item, title: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="Dedicated & Professional High Quality Team"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Icon
                    </label>
                    <select
                      value={item.icon}
                      onChange={(e) => handleArrayChange('why_choose_us_items', index, { ...item, icon: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    >
                      <option value="Users">Users</option>
                      <option value="Code">Code</option>
                      <option value="Award">Award</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Description
                  </label>
                  <textarea
                    value={item.description}
                    onChange={(e) => handleArrayChange('why_choose_us_items', index, { ...item, description: e.target.value })}
                    rows={2}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="Our experienced team of professionals is committed to delivering excellence in every project we undertake."
                  />
                </div>
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => removeArrayItem('why_choose_us_items', index)}
                    className="p-2 text-red-600 hover:text-red-700 transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-gray-500 dark:text-gray-400">No items added yet.</div>
          )}
        </div>
      </div>
    </div>
  );

  const renderLatestProjectsSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Our Latest Projects Section</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.latest_projects_title}
          onChange={(e) => handleInputChange('latest_projects_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Our Latest Projects"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.latest_projects_description}
          onChange={(e) => handleInputChange('latest_projects_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Explore our recent work and see how we've helped businesses achieve their digital goals."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Button Text
        </label>
        <input
          type="text"
          value={homeData.latest_projects_button_text}
          onChange={(e) => handleInputChange('latest_projects_button_text', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="View All"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Button Link
        </label>
        <input
          type="text"
          value={homeData.latest_projects_button_link}
          onChange={(e) => handleInputChange('latest_projects_button_link', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="/projects"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Number of Projects to Display
        </label>
        <input
          type="number"
          value={homeData.latest_projects_limit}
          onChange={(e) => handleInputChange('latest_projects_limit', parseInt(e.target.value))}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="4"
          min="1"
          max="12"
        />
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
        <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">ℹ️ Project Cards</h4>
        <p className="text-sm text-blue-700 dark:text-blue-300">
          The project cards displayed here will automatically show the latest projects from your Projects section. 
          Make sure you have projects added in Admin Panel → Projects Management.
        </p>
      </div>
    </div>
  );

  const renderTeamSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Team Section</h3>
      
      {/* Team Section Title and Button */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Section Title
          </label>
          <input
            type="text"
            value={homeData.team_title || ''}
            onChange={(e) => handleInputChange('team_title', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Meet Our Team"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Text
          </label>
          <input
            type="text"
            value={homeData.team_button_text || ''}
            onChange={(e) => handleInputChange('team_button_text', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="View All Members"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Link
          </label>
          <input
            type="text"
            value={homeData.team_button_link || ''}
            onChange={(e) => handleInputChange('team_button_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/team"
          />
        </div>
      </div>
      
      <div className="flex items-center justify-between mb-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Team Members
        </label>
        <button
          onClick={() => addArrayItem('team_members', { name: '', role: '', image: '' })}
          className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <Plus className="w-4 h-4" />
          Add Member
        </button>
      </div>
      <div className="space-y-4">
        {Array.isArray(homeData.team_members) && homeData.team_members.length > 0 ? (
          homeData.team_members.map((member, index) => (
            <div key={index} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    value={member.name}
                    onChange={(e) => handleArrayChange('team_members', index, { ...member, name: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Role
                  </label>
                  <input
                    type="text"
                    value={member.role}
                    onChange={(e) => handleArrayChange('team_members', index, { ...member, role: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="Product Manager"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Image URL
                  </label>
                  <input
                    type="text"
                    value={member.image}
                    onChange={(e) => handleArrayChange('team_members', index, { ...member, image: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="https://example.com/team-1.jpg"
                  />
                </div>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => removeArrayItem('team_members', index)}
                  className="p-2 text-red-600 hover:text-red-700 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500 dark:text-gray-400">No members added yet.</div>
        )}
      </div>
    </div>
  );

  const renderPaymentMethodsSection = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Payment Methods Section</h3>
      
      {/* Basic Fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Section Title
          </label>
          <input
            type="text"
            value={homeData.payment_methods_title || ''}
            onChange={(e) => handleInputChange('payment_methods_title', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Our Acceptable Payment Methods"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Text
          </label>
          <input
            type="text"
            value={homeData.payment_methods_button_text || ''}
            onChange={(e) => handleInputChange('payment_methods_button_text', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Learn More About Payments"
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Section Description
        </label>
        <textarea
          value={homeData.payment_methods_description || ''}
          onChange={(e) => handleInputChange('payment_methods_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="We accept all major payment methods to make your shopping experience seamless and convenient. Choose from our wide range of secure payment options."
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Button Link
          </label>
          <input
            type="text"
            value={homeData.payment_methods_button_link || ''}
            onChange={(e) => handleInputChange('payment_methods_button_link', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/payment-methods"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Left Side Image URL
          </label>
          <input
            type="text"
            value={homeData.payment_methods_image || ''}
            onChange={(e) => handleInputChange('payment_methods_image', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="/images/payment-customer.jpg"
          />
        </div>
      </div>
      
      {/* Payment Methods Logos */}
      <div className="flex items-center justify-between mb-4">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Payment Methods (Image or Link - both optional)
        </label>
        <button
          onClick={() => addArrayItem('payment_methods_logos', { name: '', image: '', link: '' })}
          className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
        >
          <Plus className="w-4 h-4" />
          Add Payment Method
        </button>
      </div>
      <div className="space-y-4">
        {Array.isArray(homeData.payment_methods_logos) && homeData.payment_methods_logos.length > 0 ? (
          homeData.payment_methods_logos.map((logo, index) => (
            <div key={index} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Name Input */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Payment Method Name
                  </label>
                  <input
                    type="text"
                    value={logo.name || ''}
                    onChange={e => handleArrayChange('payment_methods_logos', index, { ...logo, name: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="PayPal"
                  />
                </div>
                
                {/* Image Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Payment Method Image (Optional)
                  </label>
                  <div className="flex items-center gap-4">
                    <div className="flex-shrink-0 w-20 h-20 bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden flex items-center justify-center">
                      {logo.image ? (
                        <img src={logo.image} alt="Payment Method" className="w-full h-full object-contain" />
                      ) : (
                        <Image className="w-8 h-8 text-gray-400" />
                      )}
                    </div>
                    <input
                      type="text"
                      value={logo.image || ''}
                      onChange={e => handleArrayChange('payment_methods_logos', index, { ...logo, image: e.target.value })}
                      className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      placeholder="/images/payment-logos/paypal.png"
                    />
                  </div>
                </div>
                
                {/* Link Input */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Payment Method Link (Optional)
                  </label>
                  <input
                    type="text"
                    value={logo.link || ''}
                    onChange={e => handleArrayChange('payment_methods_logos', index, { ...logo, link: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="https://paypal.com"
                  />
                </div>
              </div>
              
              {/* Remove Button */}
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => removeArrayItem('payment_methods_logos', index)}
                  className="p-2 text-red-600 hover:text-red-700 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500 dark:text-gray-400">No payment methods added yet.</div>
        )}
      </div>
    </div>
  );

  const renderPricingTableSection = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Pricing Table Section</h3>
        <button
          onClick={() => saveSectionData('pricing-table')}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 transition-colors"
        >
          {saving ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          ) : (
            <Save className="w-4 h-4" />
          )}
          {saving ? 'Saving...' : 'Save Pricing Table'}
        </button>
      </div>
      
      {/* Basic Fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Section Title
          </label>
          <input
            type="text"
            value={homeData.pricing_title || ''}
            onChange={(e) => handleInputChange('pricing_title', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Flexible Plans For Your Business Growth"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Section Description
          </label>
          <input
            type="text"
            value={homeData.pricing_description || ''}
            onChange={(e) => handleInputChange('pricing_description', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            placeholder="Choose the perfect plan that fits your business needs"
          />
        </div>
      </div>
      
      {/* Left Side Card Fields */}
      <div className="border-t pt-6">
        <h4 className="text-md font-medium text-gray-900 dark:text-white mb-4">Left Side Card</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Card Title
            </label>
            <input
              type="text"
              value={homeData.pricing_left_title || ''}
              onChange={(e) => handleInputChange('pricing_left_title', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Choose Your Plan"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Present Text
            </label>
            <input
              type="text"
              value={homeData.pricing_left_monthly_text || ''}
              onChange={(e) => handleInputChange('pricing_left_monthly_text', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Present"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Future Text
            </label>
            <input
              type="text"
              value={homeData.pricing_left_yearly_text || ''}
              onChange={(e) => handleInputChange('pricing_left_yearly_text', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Future"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Description
            </label>
            <textarea
              value={homeData.pricing_left_description || ''}
              onChange={(e) => handleInputChange('pricing_left_description', e.target.value)}
              rows={2}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Compare present and future pricing to see the value of early adoption."
            />
          </div>
        </div>
      </div>
      
      {/* Button Text */}
      <div className="border-t pt-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Button Text
            </label>
            <input
              type="text"
              value={homeData.pricing_button_text || ''}
              onChange={(e) => handleInputChange('pricing_button_text', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Get Started"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Button Link
            </label>
            <input
              type="text"
              value={homeData.pricing_button_link || ''}
              onChange={(e) => handleInputChange('pricing_button_link', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="/contact or https://example.com"
            />
          </div>
        </div>
      </div>

      {/* WhatsApp Button */}
      <div className="border-t pt-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              WhatsApp Button Text
            </label>
            <input
              type="text"
              value={homeData.pricing_whatsapp_button_text || ''}
              onChange={(e) => handleInputChange('pricing_whatsapp_button_text', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              placeholder="Order on WhatsApp"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              WhatsApp Button Icon
            </label>
            <select
              value={homeData.pricing_whatsapp_button_icon || 'MessageCircle'}
              onChange={(e) => handleInputChange('pricing_whatsapp_button_icon', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            >
              {availableIcons.map(icon => (
                <option key={icon.name} value={icon.name}>
                  {icon.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Pricing Plans */}
      <div className="border-t pt-6">
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-md font-medium text-gray-900 dark:text-white">Pricing Plans</h4>
          <button
            onClick={() => addArrayItem('pricing_plans', { 
              name: '', 
              monthly_price: '', 
              yearly_price: '', 
              features: [] 
            })}
            className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Plan
          </button>
        </div>
        
        {Array.isArray(homeData.pricing_plans) && homeData.pricing_plans.length > 0 ? (
          homeData.pricing_plans.map((plan, index) => (
            <div key={index} className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 mb-4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Plan Name
                  </label>
                  <input
                    type="text"
                    value={plan.name || ''}
                    onChange={(e) => handleArrayChange('pricing_plans', index, { ...plan, name: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="Startup"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Monthly Price
                  </label>
                  <input
                    type="text"
                    value={plan.monthly_price || ''}
                    onChange={(e) => handleArrayChange('pricing_plans', index, { ...plan, monthly_price: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="29"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Yearly Price
                  </label>
                  <input
                    type="text"
                    value={plan.yearly_price || ''}
                    onChange={(e) => handleArrayChange('pricing_plans', index, { ...plan, yearly_price: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="49"
                  />
                </div>
              </div>
              
              {/* Features */}
              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Features
                  </label>
                  <button
                    onClick={() => {
                      const newFeatures = [...(plan.features || []), { text: '', icon: 'CheckCircle' }];
                      handleArrayChange('pricing_plans', index, { ...plan, features: newFeatures });
                    }}
                    className="flex items-center gap-1 px-2 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 transition-colors"
                  >
                    <Plus className="w-3 h-3" />
                    Add Feature
                  </button>
                </div>
                
                {plan.features && plan.features.length > 0 ? (
                  plan.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center gap-2 mb-2">
                      <input
                        type="text"
                        value={feature.text || ''}
                        onChange={(e) => {
                          const newFeatures = [...plan.features];
                          newFeatures[featureIndex] = { ...feature, text: e.target.value };
                          handleArrayChange('pricing_plans', index, { ...plan, features: newFeatures });
                        }}
                        className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        placeholder="Feature description"
                      />
                      <select
                        value={feature.icon || 'CheckCircle'}
                        onChange={(e) => {
                          const newFeatures = [...plan.features];
                          newFeatures[featureIndex] = { ...feature, icon: e.target.value };
                          handleArrayChange('pricing_plans', index, { ...plan, features: newFeatures });
                        }}
                        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                      >
                        <option value="CheckCircle">Check Circle</option>
                        <option value="Star">Star</option>
                        <option value="Zap">Zap</option>
                        <option value="Award">Award</option>
                        <option value="Heart">Heart</option>
                        <option value="Shield">Shield</option>
                      </select>
                      <button
                        onClick={() => {
                          const newFeatures = plan.features.filter((_, i) => i !== featureIndex);
                          handleArrayChange('pricing_plans', index, { ...plan, features: newFeatures });
                        }}
                        className="p-2 text-red-600 hover:text-red-700 transition-colors"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  ))
                ) : (
                  <div className="text-gray-500 dark:text-gray-400">No features added yet.</div>
                )}
              </div>
              
              {/* Remove Plan Button */}
              <div className="flex justify-end">
                <button
                  onClick={() => removeArrayItem('pricing_plans', index)}
                  className="p-2 text-red-600 hover:text-red-700 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500 dark:text-gray-400">No pricing plans added yet.</div>
        )}
      </div>
    </div>
  );

  const renderSupportSection = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Support Section</h3>
        <button
          onClick={() => saveSupportData()}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 transition-colors"
        >
          {saving ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          ) : (
            <Save className="w-4 h-4" />
          )}
          {saving ? 'Saving...' : 'Save Support'}
        </button>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Title
        </label>
        <input
          type="text"
          value={homeData.support_title || ''}
          onChange={(e) => handleInputChange('support_title', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Support 24/7"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Description
        </label>
        <textarea
          value={homeData.support_description || ''}
          onChange={(e) => handleInputChange('support_description', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="Our dedicated support team is available around the clock to help you with any questions or issues."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Main Button Text
        </label>
        <input
          type="text"
          value={homeData.support_button_text || ''}
          onChange={(e) => handleInputChange('support_button_text', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="support@company.com"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Main Button Link
        </label>
        <input
          type="text"
          value={homeData.support_button_link || ''}
          onChange={(e) => handleInputChange('support_button_link', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          placeholder="mailto:support@company.com"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Icon
        </label>
        <select
          value={homeData.support_icon || ''}
          onChange={(e) => handleInputChange('support_icon', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
          <option value="Headphones">Headphones</option>
          <option value="MessageCircle">Chat</option>
          <option value="Mail">Email</option>
          <option value="Phone">Phone</option>
          <option value="HelpCircle">Help</option>
        </select>
      </div>

      {/* All Support Buttons Section */}
      <div className="border-t pt-6">
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-md font-semibold text-gray-900 dark:text-white">All Support Buttons</h4>
          <button
            onClick={() => addArrayItem('support_extra_buttons', { text: '', link: '', icon: 'MessageCircle' })}
            className="flex items-center gap-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            Add Extra Button
          </button>
        </div>

        <div className="space-y-4">
          {/* Main Button Preview */}
          <div className="border border-blue-200 dark:border-blue-600 rounded-lg p-4 bg-blue-50 dark:bg-blue-900/20">
            <div className="flex items-center justify-between mb-3">
              <h5 className="text-sm font-medium text-blue-900 dark:text-blue-100">Main Support Button (Preview)</h5>
              <span className="text-xs text-blue-600 dark:text-blue-300">This button appears on the website</span>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-xs font-medium text-blue-700 dark:text-blue-300 mb-1">
                  Button Text
                </label>
                <input
                  type="text"
                  value={homeData.support_button_text || ''}
                  onChange={(e) => handleInputChange('support_button_text', e.target.value)}
                  className="w-full px-2 py-1 text-xs border border-blue-300 dark:border-blue-600 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  placeholder="support@company.com"
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-blue-700 dark:text-blue-300 mb-1">
                  Button Link
                </label>
                <input
                  type="text"
                  value={homeData.support_button_link || ''}
                  onChange={(e) => handleInputChange('support_button_link', e.target.value)}
                  className="w-full px-2 py-1 text-xs border border-blue-300 dark:border-blue-600 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  placeholder="mailto:support@company.com"
                />
              </div>
              
              <div>
                <label className="block text-xs font-medium text-blue-700 dark:text-blue-300 mb-1">
                  Button Icon
                </label>
                <select
                  value={homeData.support_icon || 'Headphones'}
                  onChange={(e) => handleInputChange('support_icon', e.target.value)}
                  className="w-full px-2 py-1 text-xs border border-blue-300 dark:border-blue-600 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                  <option value="Headphones">Headphones</option>
                  <option value="MessageCircle">Chat</option>
                  <option value="Mail">Email</option>
                  <option value="Phone">Phone</option>
                  <option value="HelpCircle">Help</option>
                </select>
              </div>
              
              <div>
                <label className="block text-xs font-medium text-blue-700 dark:text-blue-300 mb-1">
                  Large Right Icon
                </label>
                <select
                  value={homeData.support_large_icon || 'Headphones'}
                  onChange={(e) => handleInputChange('support_large_icon', e.target.value)}
                  className="w-full px-2 py-1 text-xs border border-blue-300 dark:border-blue-600 rounded focus:ring-1 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                  <option value="Headphones">Headphones</option>
                  <option value="MessageCircle">Chat</option>
                  <option value="Mail">Email</option>
                  <option value="Phone">Phone</option>
                  <option value="HelpCircle">Help</option>
                  <option value="Globe">Globe</option>
                  <option value="Zap">Zap</option>
                  <option value="Star">Star</option>
                  <option value="Heart">Heart</option>
                  <option value="CheckCircle">Check</option>
                  <option value="Users">Users</option>
                  <option value="Settings">Settings</option>
                  <option value="Code">Code</option>
                  <option value="Shield">Shield</option>
                  <option value="Award">Award</option>
                </select>
              </div>
            </div>
            
            {/* Main Button Preview */}
            <div className="flex items-center gap-2">
              <span className="text-xs text-blue-600 dark:text-blue-300">Preview:</span>
              <a 
                href={homeData?.support_button_link || '#'} 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#1B1B1B] dark:bg-white text-white dark:text-black px-3 py-2 rounded-lg font-medium text-xs hover:opacity-90 transition-opacity"
              >
                {(() => {
                  const IconComponent = getIconComponent(homeData?.support_icon || 'Headphones');
                  return <IconComponent className="w-3 h-3" />;
                })()}
                {homeData?.support_button_text || 'support@company.com'}
              </a>
            </div>
          </div>


          {Array.isArray(homeData.support_extra_buttons) && homeData.support_extra_buttons.map((button, index) => (
            <div key={index} className="border border-gray-200 dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-gray-800">
              <div className="flex items-center justify-between mb-3">
                <h5 className="text-sm font-medium text-gray-900 dark:text-white">Extra Button {index + 1}</h5>
                <button
                  onClick={() => removeArrayItem('support_extra_buttons', index)}
                  className="text-red-500 hover:text-red-700 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Button Text
                  </label>
                  <input
                    type="text"
                    value={button.text || ''}
                    onChange={(e) => handleArrayChange('support_extra_buttons', index, { ...button, text: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="Live Chat"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Button Link
                  </label>
                  <input
                    type="text"
                    value={button.link || ''}
                    onChange={(e) => handleArrayChange('support_extra_buttons', index, { ...button, link: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    placeholder="https://chat.example.com"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Icon
                  </label>
                  <select
                    value={button.icon || 'MessageCircle'}
                    onChange={(e) => handleArrayChange('support_extra_buttons', index, { ...button, icon: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  >
                    <option value="MessageCircle">Chat</option>
                    <option value="Phone">Phone</option>
                    <option value="Mail">Email</option>
                    <option value="Headphones">Headphones</option>
                    <option value="HelpCircle">Help</option>
                    <option value="Globe">Globe</option>
                    <option value="Zap">Zap</option>
                    <option value="Star">Star</option>
                    <option value="Heart">Heart</option>
                    <option value="CheckCircle">Check</option>
                  </select>
                </div>
              </div>
              
              {/* Extra Button Preview */}
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-600 dark:text-gray-300">Preview:</span>
                <a 
                  href={button.link || '#'} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-white/80 dark:bg-gray-800/80 text-[#1B1B1B] dark:text-white px-3 py-2 rounded-lg font-medium text-xs hover:opacity-90 transition-opacity border border-gray-200 dark:border-gray-600"
                >
                  {(() => {
                    const IconComponent = getIconComponent(button.icon || 'MessageCircle');
                    return <IconComponent className="w-3 h-3" />;
                  })()}
                  {button.text || 'Button Text'}
                </a>
              </div>
            </div>
          ))}
          
          {(!Array.isArray(homeData.support_extra_buttons) || homeData.support_extra_buttons.length === 0) && (
            <div className="text-center py-8 text-gray-500 dark:text-gray-400">
              <MessageCircle className="w-12 h-12 mx-auto mb-2 opacity-50" />
              <p>No extra buttons added yet.</p>
              <p className="text-sm">Click "Add Button" to create additional support buttons.</p>
            </div>
          )}
        </div>
      </div>

      <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg">
        <p className="text-sm text-green-700 dark:text-green-300">
          <strong>Info:</strong> Extra buttons will be displayed below the main support button on the website.
        </p>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeSection) {
      case 'hero':
        return renderHeroSection();
      case 'hero-spline':
        return renderHeroSplineSection();
      case 'hero-banner':
        return renderHeroBannerSection();
      case 'hero-stats':
        return renderHeroStatsSection();
      case 'brand-logos':
        return renderBrandLogosSection();
      case 'services':
        return renderServicesSection();
      case 'testimonials':
        return renderTestimonialsSection();
      case 'more':
        return renderMoreSection();
      case 'newsletter':
        return renderNewsletterSection();
      case 'support':
        return renderSupportSection();
      case 'team':
        return renderTeamSection();
      case 'payment-methods':
        return renderPaymentMethodsSection();
      case 'pricing-table':
        return renderPricingTableSection();
      case 'featured-products':
        return renderFeaturedProductsSection();
      case 'working-process':
        return renderWorkingProcessSection();
      case 'why-choose-us':
        return renderWhyChooseUsSection();
      case 'latest-projects':
        return renderLatestProjectsSection();
      case 'about':
        return (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">About Us Section</h3>
              <button
                onClick={() => saveSectionData('about')}
                disabled={saving}
                className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 transition-colors"
              >
                {saving ? (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                ) : (
                  <Save className="w-4 h-4" />
                )}
                {saving ? 'Saving...' : 'Save About Us'}
              </button>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Subtitle
              </label>
              <input
                type="text"
                value={homeData.about_subtitle}
                onChange={(e) => handleInputChange('about_subtitle', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Best Services We Provide"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Title
              </label>
              <input
                type="text"
                value={homeData.about_title}
                onChange={(e) => handleInputChange('about_title', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Best Services We Provide"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Description
              </label>
              <textarea
                value={homeData.about_description}
                onChange={(e) => handleInputChange('about_description', e.target.value)}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="Every month we pick some best products for you. This month's best web themes & templates have arrived, chosen by our content specialists."
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Image URL
              </label>
              <input
                type="text"
                value={homeData.about_image}
                onChange={(e) => handleInputChange('about_image', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="https://example.com/about-main.jpg"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Experience Years
              </label>
              <input
                type="text"
                value={homeData.about_experience_years}
                onChange={(e) => handleInputChange('about_experience_years', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="25+"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Button Text
              </label>
              <input
                type="text"
                value={homeData.about_button_text}
                onChange={(e) => handleInputChange('about_button_text', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="More About Us"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Button Link
              </label>
              <input
                type="text"
                value={homeData.about_button_link}
                onChange={(e) => handleInputChange('about_button_link', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder="/about"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Features
              </label>
              <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Feature Items
                </label>
                <button
                  onClick={() => addArrayItem('about_features', { title: '', description: '', icon: 'Check' })}
                  className="flex items-center gap-2 px-3 py-1 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
                >
                  <Plus className="w-4 h-4" />
                  Add Feature
                </button>
              </div>
              <div className="space-y-4">
                {Array.isArray(homeData.about_features) && homeData.about_features.length > 0 ? (
                  homeData.about_features.map((feature, index) => (
                    <div key={index} className="p-4 border border-gray-200 dark:border-gray-600 rounded-lg">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Feature Title
                          </label>
                          <input
                            type="text"
                            value={feature.title}
                            onChange={(e) => handleArrayChange('about_features', index, { ...feature, title: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="High Quality Services"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Feature Description
                          </label>
                          <textarea
                            value={feature.description}
                            onChange={(e) => handleArrayChange('about_features', index, { ...feature, description: e.target.value })}
                            rows={2}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="Lorem ipsum dolor sit amet consectetur. Lobortis aliquet tincidunt donec turpis nibh nunc dolor feugiat tellus."
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Feature Icon
                          </label>
                          <select
                            value={feature.icon}
                            onChange={(e) => handleArrayChange('about_features', index, { ...feature, icon: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          >
                            <option value="Check">Check</option>
                            <option value="ArrowRight">ArrowRight</option>
                            <option value="Heart">Heart</option>
                            <option value="Target">Target</option>
                            <option value="Zap">Zap</option>
                            <option value="Shield">Shield</option>
                            <option value="Users">Users</option>
                            <option value="Award">Award</option>
                          </select>
                        </div>
                      </div>
                      <div className="mt-4 flex justify-end">
                        <button
                          onClick={() => removeArrayItem('about_features', index)}
                          className="p-2 text-red-600 hover:text-red-700 transition-colors"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-gray-500 dark:text-gray-400">No features added yet.</div>
                )}
              </div>
            </div>
          </div>
        );
      default:
        return renderHeroSection();
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white">Homepage Management</h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2">
              Manage all homepage content and sections
            </p>
          </div>
          
          <div className="flex items-center gap-4">
            {isEditing ? (
              <>
                <button
                  onClick={() => setIsEditing(false)}
                  className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancel
                </button>
            <button
                  onClick={saveHomepageData}
                  disabled={saving}
                  className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 transition-colors"
                >
                  {saving ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  ) : (
                    <Save className="w-4 h-4" />
                  )}
                  {saving ? 'Saving...' : 'Save Changes'}
            </button>
              </>
            ) : (
              <button
                onClick={() => setIsEditing(true)}
                className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
              >
                <Edit className="w-4 h-4" />
                Edit Content
              </button>
            )}
          </div>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
            <div className="flex items-center gap-2 text-red-800 dark:text-red-200">
              <AlertCircle className="w-5 h-5" />
              <span>{error}</span>
        </div>
      </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4 sm:p-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Sections</h3>
            <nav className="space-y-2">
              {sections.map((section) => {
                  const IconComponent = section.icon;
                return (
                  <button
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                      className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors ${
                      activeSection === section.id
                          ? 'bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300'
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                  >
                      <IconComponent className="w-4 h-4" />
                      <span className="text-sm font-medium">{section.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Main Content */}
          <div className="lg:col-span-3">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4 sm:p-6">
              {renderContent()}
                </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageManagement;
